export default __webpack_public_path__ + "static/media/Heaven's Dan Sang Gum.bc5f3b11.jpg";